import { Notifications } from "@app/types/core.types";

export function hasNotification(notifications: Notifications[], targetProperty: string): boolean {
    if (notifications && notifications.length > 0) {
        return notifications.some(notification => notification.property === targetProperty);
    }
    return false;
}